// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import {
//   getFreelancers,
//   getFreelancerById,
//   createFreelancer,
//   updateFreelancer,
//   deleteFreelancer,
//   permanentDeleteFreelancer,
//   updateFreelancerPassword,
//   bulkCreateFreelancers,
//   approveFreelancer,
//   rejectFreelancer,
//   toggleFreelancerStatus,
//   updateFreelancerPermissions,
//   getFreelancerStats,
// } from '../../Services/Operations/ProductAPI';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//    </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Name</th>
//           <th>Email</th>
//           <th>Phone</th>
//           <th>Employee ID</th>
//           <th>Department</th>
//           <th>Designation</th>
//           <th>Status</th>
//           <th>Approval</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="skeleton-profile-image"></div>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonEditModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 edit-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const FreelancerManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [freelancers, setFreelancers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingFreelancer, setEditingFreelancer] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingFreelancer, setViewingFreelancer] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [addForm, setAddForm] = useState({
//     name: '',
//     email: '',
//     password: '',
//     phone: '',
//     dateOfBirth: '',
//     gender: '',
//     address: {
//       street: '',
//       city: '',
//       state: '',
//       pincode: '',
//       country: 'India'
//     },
//     department: 'Operations',
//     designation: 'Freelancer'
//   });
//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [passwordForm, setPasswordForm] = useState({
//     newPassword: ''
//   });
//   const [selectedFreelancerId, setSelectedFreelancerId] = useState(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [deleteType, setDeleteType] = useState('soft');
//   const [freelancerToDelete, setFreelancerToDelete] = useState(null);
//   const [showBulkModal, setShowBulkModal] = useState(false);
//   const [bulkFreelancers, setBulkFreelancers] = useState('');
//   const [showPermissionsModal, setShowPermissionsModal] = useState(false);
//   const [permissionsForm, setPermissionsForm] = useState({
//     canManageDrivers: true,
//     canManageConductors: true,
//     canManageBusOwners: true,
//     canManageRoutes: true,
//     canViewDashboard: true,
//     canViewProfile: true
//   });
//   const [filters, setFilters] = useState({
//     status: '',
//     approval: ''
//   });
//   const [stats, setStats] = useState({
//     total: 0,
//     active: 0,
//     pending: 0,
//     inactive: 0
//   });

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalFreelancers, setTotalFreelancers] = useState(0);
//   const [pageSize] = useState(10);

//   const genderOptions = ['male', 'female', 'other'];
//   const departmentOptions = ['Operations', 'IT', 'HR', 'Finance', 'Sales', 'Marketing', 'Customer Support'];
//   const statusOptions = ['active', 'inactive'];
//   const approvalOptions = ['approved', 'pending'];

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   useEffect(() => {
//     fetchStats();
//   }, []);

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchFreelancers();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters]);

//   const fetchStats = async () => {
//     try {
//       const response = await getFreelancerStats(token);
//       if (response.success) {
//         setStats(response.data);
//       }
//     } catch (err) {
//       console.error('Error fetching stats:', err);
//     }
//   };

//   const fetchFreelancers = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       const response = await getFreelancers(
//         token, 
//         currentPage, 
//         pageSize, 
//         searchTerm,
//         filters.status,
//         filters.approval
//       );

//       if (response && response.success) {
//         const transformedFreelancers = response.data.freelancers.map((freelancer, index) => ({
//           id: freelancer._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: freelancer.profilePicture,
//           name: freelancer.name || '',
//           email: freelancer.email || '',
//           phone: freelancer.phone || '',
//           employeeId: freelancer.employeeId || '',
//           department: freelancer.department || '',
//           designation: freelancer.designation || '',
//           isActive: freelancer.isActive || false,
//           isApproved: freelancer.isApproved || false,
//           approvedBy: freelancer.approvedBy,
//           joined: new Date(freelancer.createdAt).toISOString().split('T')[0],
//           status: freelancer.isActive ? 'Active' : 'Inactive',
//           approvalStatus: freelancer.isApproved ? 'Approved' : 'Pending',
//           permissions: freelancer.permissions || {}
//         }));

//         setFreelancers(transformedFreelancers);
//         setTotalPages(response.data.pagination.totalPages || 1);
//         setTotalFreelancers(response.data.pagination.totalItems || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch freelancers.');
//       console.error('Error fetching freelancers:', err);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleViewFreelancer = async (freelancerId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getFreelancerById(freelancerId, token);
      
//       if (response.success) {
//         const freelancer = response.data;
//         setViewingFreelancer({
//           id: freelancer._id,
//           name: freelancer.name || '',
//           email: freelancer.email || '',
//           phone: freelancer.phone || '',
//           employeeId: freelancer.employeeId || '',
//           department: freelancer.department || '',
//           designation: freelancer.designation || '',
//           isActive: freelancer.isActive,
//           isApproved: freelancer.isApproved,
//           profileImage: freelancer.profilePicture,
//           address: freelancer.address,
//           gender: freelancer.gender,
//           dateOfBirth: freelancer.dateOfBirth ? new Date(freelancer.dateOfBirth).toLocaleDateString() : 'N/A',
//           permissions: freelancer.permissions,
//           createdAt: new Date(freelancer.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(freelancer.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           })
//         });
//       } else {
//         setError('Failed to fetch freelancer details.');
//       }
//     } catch (err) {
//       console.error('Error fetching freelancer details:', err);
//       setError('Failed to fetch freelancer details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditFreelancer = async (freelancerId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getFreelancerById(freelancerId, token);
      
//       if (response.success) {
//         const freelancer = response.data;
//         setEditingFreelancer(freelancer._id);
//         setEditForm({
//           name: freelancer.name || '',
//           email: freelancer.email || '',
//           phone: freelancer.phone || '',
//           department: freelancer.department || 'Operations',
//           designation: freelancer.designation || 'Freelancer',
//           gender: freelancer.gender || '',
//           dateOfBirth: freelancer.dateOfBirth ? freelancer.dateOfBirth.split('T')[0] : '',
//           address: freelancer.address || {
//             street: '',
//             city: '',
//             state: '',
//             pincode: '',
//             country: 'India'
//           },
//           isActive: freelancer.isActive || true
//         });
//       } else {
//         setError('Failed to fetch freelancer details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching freelancer details for editing:', err);
//       setError('Failed to fetch freelancer details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         department: editForm.department,
//         designation: editForm.designation,
//         gender: editForm.gender,
//         dateOfBirth: editForm.dateOfBirth,
//         address: editForm.address,
//         isActive: editForm.isActive
//       };

//       const response = await updateFreelancer(editingFreelancer, updateData, token);
      
//       if (response.success) {
//         setFreelancers(prevFreelancers =>
//           prevFreelancers.map(freelancer =>
//             freelancer.id === editingFreelancer ? {
//               ...freelancer,
//               name: response.data.name,
//               email: response.data.email,
//               phone: response.data.phone,
//               department: response.data.department,
//               designation: response.data.designation,
//               status: response.data.isActive ? 'Active' : 'Inactive',
//               isActive: response.data.isActive
//             } : freelancer
//           )
//         );

//         setEditingFreelancer(null);
//         setEditForm({});
//         alert('Freelancer updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update freelancer.');
//       }
//     } catch (err) {
//       console.error('Error updating freelancer:', err);
//       setError(err.response?.data?.message || 'Failed to update freelancer. Please try again.');
//       alert('Failed to update freelancer. Please try again.');
//     }
//   };

//   const handleAddFreelancer = async () => {
//     try {
//       setError(null);
      
//       const response = await createFreelancer(addForm, token);
      
//       if (response.success) {
//         setShowAddModal(false);
//         setAddForm({
//           name: '',
//           email: '',
//           password: '',
//           phone: '',
//           dateOfBirth: '',
//           gender: '',
//           address: {
//             street: '',
//             city: '',
//             state: '',
//             pincode: '',
//             country: 'India'
//           },
//           department: 'Operations',
//           designation: 'Freelancer'
//         });
//         fetchFreelancers();
//         fetchStats();
//         alert('Freelancer created successfully!');
//       } else {
//         setError(response.message || 'Failed to create freelancer.');
//       }
//     } catch (err) {
//       console.error('Error creating freelancer:', err);
//       setError(err.response?.data?.message || 'Failed to create freelancer. Please try again.');
//     }
//   };

//   const handleUpdatePassword = async () => {
//     try {
//       setError(null);
      
//       const response = await updateFreelancerPassword(selectedFreelancerId, passwordForm, token);
      
//       if (response.success) {
//         setShowPasswordModal(false);
//         setPasswordForm({ newPassword: '' });
//         setSelectedFreelancerId(null);
//         alert('Password updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update password.');
//       }
//     } catch (err) {
//       console.error('Error updating password:', err);
//       setError(err.response?.data?.message || 'Failed to update password. Please try again.');
//     }
//   };

//   const handleDeleteFreelancer = async () => {
//     try {
//       setError(null);
      
//       let response;
//       if (deleteType === 'permanent') {
//         response = await permanentDeleteFreelancer(freelancerToDelete, token);
//       } else {
//         response = await deleteFreelancer(freelancerToDelete, token);
//       }
      
//       if (response.success) {
//         setShowDeleteConfirm(false);
//         setFreelancerToDelete(null);
//         fetchFreelancers();
//         fetchStats();
//         alert(`Freelancer ${deleteType === 'permanent' ? 'permanently deleted' : 'deactivated'} successfully!`);
//       } else {
//         setError(response.message || 'Failed to delete freelancer.');
//       }
//     } catch (err) {
//       console.error('Error deleting freelancer:', err);
//       setError(err.response?.data?.message || 'Failed to delete freelancer. Please try again.');
//     }
//   };

//   const handleApproveFreelancer = async (freelancerId) => {
//     try {
//       const response = await approveFreelancer(freelancerId, token);
//       if (response.success) {
//         fetchFreelancers();
//         fetchStats();
//         alert('Freelancer approved successfully!');
//       }
//     } catch (err) {
//       console.error('Error approving freelancer:', err);
//       setError('Failed to approve freelancer.');
//     }
//   };

//   const handleRejectFreelancer = async (freelancerId) => {
//     try {
//       const response = await rejectFreelancer(freelancerId, token);
//       if (response.success) {
//         fetchFreelancers();
//         fetchStats();
//         alert('Freelancer rejected successfully!');
//       }
//     } catch (err) {
//       console.error('Error rejecting freelancer:', err);
//       setError('Failed to reject freelancer.');
//     }
//   };

//   const handleToggleStatus = async (freelancerId) => {
//     try {
//       const response = await toggleFreelancerStatus(freelancerId, token);
//       if (response.success) {
//         fetchFreelancers();
//         fetchStats();
//         alert(`Freelancer ${response.data.isActive ? 'activated' : 'deactivated'} successfully!`);
//       }
//     } catch (err) {
//       console.error('Error toggling freelancer status:', err);
//       setError('Failed to toggle freelancer status.');
//     }
//   };

//   const handleUpdatePermissions = async () => {
//     try {
//       const response = await updateFreelancerPermissions(selectedFreelancerId, permissionsForm, token);
//       if (response.success) {
//         setShowPermissionsModal(false);
//         setSelectedFreelancerId(null);
//         alert('Permissions updated successfully!');
//       }
//     } catch (err) {
//       console.error('Error updating permissions:', err);
//       setError('Failed to update permissions.');
//     }
//   };

// const handleBulkCreate = async () => {
//   try {
//     setError(null);
    
//     if (!bulkFreelancers || bulkFreelancers.trim() === '') {
//       setError('Please enter freelancer data.');
//       return;
//     }
    
//     let freelancersData;
//     try {
//       freelancersData = JSON.parse(bulkFreelancers);
//     } catch (e) {
//       setError('Invalid JSON format. Please check your input. Error: ' + e.message);
//       return;
//     }
    
//     // ✅ Validate that it's an array
//     if (!Array.isArray(freelancersData)) {
//       setError('Invalid format: Please provide an array of freelancers. Example: [{ "name": "John", "email": "john@example.com", "password": "password123" }]');
//       return;
//     }
    
//     // ✅ Validate array is not empty
//     if (freelancersData.length === 0) {
//       setError('Please provide at least one freelancer to create.');
//       return;
//     }
    
//     // ✅ Validate each item has required fields
//     const requiredFields = ['name', 'email', 'password'];
//     const missingFields = [];
    
//     freelancersData.forEach((item, index) => {
//       requiredFields.forEach(field => {
//         if (!item[field] || item[field].trim() === '') {
//           missingFields.push(`Item ${index + 1}: Missing "${field}"`);
//         }
//       });
//     });
    
//     if (missingFields.length > 0) {
//       setError(`Missing required fields:\n${missingFields.join('\n')}`);
//       return;
//     }
    
//     // ✅ Validate email format
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const invalidEmails = [];
    
//     freelancersData.forEach((item, index) => {
//       if (item.email && !emailRegex.test(item.email)) {
//         invalidEmails.push(`Item ${index + 1}: Invalid email "${item.email}"`);
//       }
//     });
    
//     if (invalidEmails.length > 0) {
//       setError(`Invalid email format:\n${invalidEmails.join('\n')}`);
//       return;
//     }
    
//     // ✅ Validate password length
//     const shortPasswords = [];
//     freelancersData.forEach((item, index) => {
//       if (item.password && item.password.length < 8) {
//         shortPasswords.push(`Item ${index + 1}: Password must be at least 8 characters`);
//       }
//     });
    
//     if (shortPasswords.length > 0) {
//       setError(`Password requirements:\n${shortPasswords.join('\n')}`);
//       return;
//     }
    
//     const response = await bulkCreateFreelancers(freelancersData, token);
    
//     if (response.success) {
//       setShowBulkModal(false);
//       setBulkFreelancers('');
//       fetchFreelancers();
//       fetchStats();
//       alert(`${response.data.created?.length || freelancersData.length} freelancers created successfully!`);
//     } else {
//       setError(response.message || 'Failed to create freelancers.');
//     }
//   } catch (err) {
//     console.error('Error bulk creating freelancers:', err);
//     setError(err.response?.data?.message || 'Failed to create freelancers. Please try again.');
//   }
// };

//   const handleCancelEdit = () => {
//     setEditingFreelancer(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     if (name.includes('.')) {
//       const [parent, child] = name.split('.');
//       setEditForm(prev => ({
//         ...prev,
//         [parent]: {
//           ...prev[parent],
//           [child]: value
//         }
//       }));
//     } else {
//       setEditForm(prev => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value
//       }));
//     }
//   };

//   const handleAddFormChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name.includes('.')) {
//       const [parent, child] = name.split('.');
//       setAddForm(prev => ({
//         ...prev,
//         [parent]: {
//           ...prev[parent],
//           [child]: value
//         }
//       }));
//     } else {
//       setAddForm(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
//   };

//   const handlePasswordFormChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePermissionsChange = (e) => {
//     const { name, checked } = e.target;
//     setPermissionsForm(prev => ({
//       ...prev,
//       [name]: checked
//     }));
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     setCurrentPage(1);
//   };

//   const closeViewModal = () => {
//     setViewingFreelancer(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     setSearchTerm('');
//     setFilters({ status: '', approval: '' });
//     fetchFreelancers();
//     fetchStats();
//   };

//   const handleExportCSV = () => {
//     const headers = ['Name', 'Email', 'Phone', 'Employee ID', 'Department', 'Designation', 'Status', 'Approval', 'Joined'];
//     const csvData = freelancers.map(freelancer => [
//       freelancer.name,
//       freelancer.email,
//       freelancer.phone,
//       freelancer.employeeId,
//       freelancer.department,
//       freelancer.designation,
//       freelancer.status,
//       freelancer.approvalStatus,
//       freelancer.joined
//     ]);
    
//     const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `freelancers_${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   if (loading && freelancers.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="filters-section">
//           <div className="skeleton-filter"></div>
//           <div className="skeleton-filter"></div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Freelancer Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search freelancers by name, email, phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Freelancer
//           </button>
//           <button className="bulk-btn" onClick={() => setShowBulkModal(true)}>
//             Bulk Create
//           </button>
//         </div>
//       </div>


//       <div className="filters-section">
//         <select name="status" value={filters.status} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Status</option>
//           {statusOptions.map(status => (
//             <option key={status} value={status}>{status}</option>
//           ))}
//         </select>
//         <select name="approval" value={filters.approval} onChange={handleFilterChange} className="filter-select">
//           <option value="">All Approval</option>
//           {approvalOptions.map(approval => (
//             <option key={approval} value={approval}>{approval}</option>
//           ))}
//         </select>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Freelancers</h3>
//           <p>{stats.total}</p>
//           <span>All registered freelancers</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active</h3>
//           <p>{stats.active}</p>
//           <span>Active freelancers</span>
//         </div>
//         <div className="stat-card">
//           <h3>Pending Approval</h3>
//           <p>{stats.pending}</p>
//           <span>Awaiting approval</span>
//         </div>
//         <div className="stat-card">
//           <h3>Inactive</h3>
//           <p>{stats.inactive}</p>
//           <span>Deactivated</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Employee ID</th>
//               <th>Department</th>
//               <th>Designation</th>
//               <th>Status</th>
//               <th>Approval</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {freelancers.map(freelancer => (
//               <tr key={freelancer.id}>
//                 <td>{freelancer.serialNo}</td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Name"
//                     />
//                   ) : (
//                     <div className="employee-name-cell">
//                       {freelancer.profileImage && (
//                         <img 
//                           src={`${process.env.REACT_APP_BASE_URL}/uploads/${freelancer.profileImage}`}
//                           alt={freelancer.name}
//                           className="employee-avatar-small"
//                           onError={(e) => e.target.style.display = 'none'}
//                         />
//                       )}
//                       <span>{freelancer.name || 'N/A'}</span>
//                     </div>
//                   )}
//                 </td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <input
//                       type="email"
//                       name="email"
//                       value={editForm.email || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Email"
//                     />
//                   ) : (
//                     freelancer.email || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <input
//                       type="text"
//                       name="phone"
//                       value={editForm.phone || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Phone"
//                     />
//                   ) : (
//                     freelancer.phone || 'N/A'
//                   )}
//                 </td>
//                 <td>{freelancer.employeeId || 'N/A'}</td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <select
//                       name="department"
//                       value={editForm.department || 'Operations'}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       {departmentOptions.map(dept => (
//                         <option key={dept} value={dept}>{dept}</option>
//                       ))}
//                     </select>
//                   ) : (
//                     freelancer.department || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <input
//                       type="text"
//                       name="designation"
//                       value={editForm.designation || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Designation"
//                     />
//                   ) : (
//                     freelancer.designation || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">
//                         {editForm.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </label>
//                   ) : (
//                     <span className={`status-badge ${freelancer.status.toLowerCase()}`}>
//                       {freelancer.status}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   <span className={`status-badge ${freelancer.approvalStatus.toLowerCase()}`}>
//                     {freelancer.approvalStatus}
//                   </span>
//                 </td>
//                 <td>
//                   {editingFreelancer === freelancer.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                         {isFetchingDetails ? 'Saving...' : 'Save'}
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewFreelancer(freelancer.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'View'}
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditFreelancer(freelancer.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'Edit'}
//                       </button>
//                       {!freelancer.isApproved && (
//                         <>
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveFreelancer(freelancer.id)}
//                             disabled={isFetchingDetails}
//                           >
//                             Approve
//                           </button>
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectFreelancer(freelancer.id)}
//                             disabled={isFetchingDetails}
//                           >
//                             Reject
//                           </button>
//                         </>
//                       )}
//                       <button
//                         className="action-btn password"
//                         onClick={() => {
//                           setSelectedFreelancerId(freelancer.id);
//                           setShowPasswordModal(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         Password
//                       </button>
//                       <button
//                         className="action-btn permissions"
//                         onClick={() => {
//                           setSelectedFreelancerId(freelancer.id);
//                           setPermissionsForm(freelancer.permissions);
//                           setShowPermissionsModal(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         Permissions
//                       </button>
//                       <button
//                         className="action-btn delete"
//                         onClick={() => {
//                           setFreelancerToDelete(freelancer.id);
//                           setDeleteType('soft');
//                           setShowDeleteConfirm(true);
//                         }}
//                         disabled={isFetchingDetails}
//                       >
//                         {freelancer.isActive ? 'Deactivate' : 'Activate'}
//                       </button>
//                       <button
//                         className="action-btn permanent-delete"
//                         onClick={() => {
//                           setFreelancerToDelete(freelancer.id);
//                           setDeleteType('permanent');
//                           setShowDeleteConfirm(true);
//                         }}
//                         disabled={isFetchingDetails}
//                         title="Permanently Delete"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {freelancers.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No freelancers found matching your search.</p>
//             {searchTerm && (
//               <button className="clear-filters-link" onClick={handleRefresh}>
//                 Clear search to see all freelancers
//               </button>
//             )}
//           </div>
//         )}
//       </div>


//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {freelancers.length} of {totalFreelancers} freelancers (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>


//       {viewingFreelancer && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Freelancer Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 {viewingFreelancer.profileImage && (
//                   <div className="customer-profile-image">
//                     <img
//                       src={`${process.env.REACT_APP_BASE_URL}/uploads/${viewingFreelancer.profileImage}`}
//                       alt={viewingFreelancer.name}
//                       className="profile-image-large"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.style.display = 'none';
//                       }}
//                     />
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingFreelancer.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingFreelancer.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingFreelancer.phone || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Employee ID:</label>
//                   <span>{viewingFreelancer.employeeId || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Department:</label>
//                   <span>{viewingFreelancer.department || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Designation:</label>
//                   <span>{viewingFreelancer.designation || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Gender:</label>
//                   <span>{viewingFreelancer.gender || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Date of Birth:</label>
//                   <span>{viewingFreelancer.dateOfBirth || 'N/A'}</span>
//                 </div>
//                 {viewingFreelancer.address && (
//                   <div className="detail-row">
//                     <label>Address:</label>
//                     <span>
//                       {[
//                         viewingFreelancer.address.street,
//                         viewingFreelancer.address.city,
//                         viewingFreelancer.address.state,
//                         viewingFreelancer.address.pincode,
//                         viewingFreelancer.address.country
//                       ].filter(Boolean).join(', ') || 'N/A'}
//                     </span>
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Permissions:</label>
//                   <div className="permissions-list">
//                     {viewingFreelancer.permissions && (
//                       <ul>
//                         <li>Manage Drivers: {viewingFreelancer.permissions.canManageDrivers ? '✅' : '❌'}</li>
//                         <li>Manage Conductors: {viewingFreelancer.permissions.canManageConductors ? '✅' : '❌'}</li>
//                         <li>Manage Bus Owners: {viewingFreelancer.permissions.canManageBusOwners ? '✅' : '❌'}</li>
//                         <li>Manage Routes: {viewingFreelancer.permissions.canManageRoutes ? '✅' : '❌'}</li>
//                       </ul>
//                     )}
//                   </div>
//                 </div>
//                 <div className="detail-row">
//                   <label>Created Date:</label>
//                   <span>{viewingFreelancer.createdAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{viewingFreelancer.updatedAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingFreelancer.isActive ? 'active' : 'inactive'}`}>
//                     {viewingFreelancer.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Approval:</label>
//                   <span className={`status-badge ${viewingFreelancer.isApproved ? 'approved' : 'pending'}`}>
//                     {viewingFreelancer.isApproved ? 'Approved' : 'Pending'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingFreelancer && isFetchingDetails && <SkeletonModal />}


//       {showAddModal && (
//         <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
//           <div className="modal-content1 add-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Freelancer</h3>
//               <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:*</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={addForm.name}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Freelancer Name"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email:*</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={addForm.email}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Email Address"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Password:*</label>
//                   <input
//                     type="password"
//                     name="password"
//                     value={addForm.password}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Password"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Phone:*</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={addForm.phone}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Phone Number"
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Gender:</label>
//                   <select
//                     name="gender"
//                     value={addForm.gender}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                   >
//                     <option value="">Select Gender</option>
//                     {genderOptions.map(gender => (
//                       <option key={gender} value={gender}>{gender}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Date of Birth:</label>
//                   <input
//                     type="date"
//                     name="dateOfBirth"
//                     value={addForm.dateOfBirth}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Department:</label>
//                   <select
//                     name="department"
//                     value={addForm.department}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                   >
//                     {departmentOptions.map(dept => (
//                       <option key={dept} value={dept}>{dept}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Designation:</label>
//                   <input
//                     type="text"
//                     name="designation"
//                     value={addForm.designation}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Designation"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Address:</label>
//                   <input
//                     type="text"
//                     name="address.street"
//                     value={addForm.address.street}
//                     onChange={handleAddFormChange}
//                     className="form-control"
//                     placeholder="Street"
//                   />
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.city"
//                       value={addForm.address.city}
//                       onChange={handleAddFormChange}
//                       className="form-control"
//                       placeholder="City"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.state"
//                       value={addForm.address.state}
//                       onChange={handleAddFormChange}
//                       className="form-control"
//                       placeholder="State"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.pincode"
//                       value={addForm.address.pincode}
//                       onChange={handleAddFormChange}
//                       className="form-control"
//                       placeholder="Pincode"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.country"
//                       value={addForm.address.country}
//                       onChange={handleAddFormChange}
//                       className="form-control"
//                       placeholder="Country"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowAddModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddFreelancer}>
//                 Create Freelancer
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showPasswordModal && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={() => setShowPasswordModal(false)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Reset Password</h3>
//               <button className="modal-close-btn" onClick={() => setShowPasswordModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>New Password:</label>
//                   <input
//                     type="password"
//                     name="newPassword"
//                     value={passwordForm.newPassword}
//                     onChange={handlePasswordFormChange}
//                     className="form-control"
//                     placeholder="New Password"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowPasswordModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleUpdatePassword}>
//                 Reset Password
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {editingFreelancer && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Edit Freelancer</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Freelancer Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Email:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={editForm.email || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Email Address"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Phone:</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={editForm.phone || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Phone Number"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Department:</label>
//                   <select
//                     name="department"
//                     value={editForm.department || 'Operations'}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     {departmentOptions.map(dept => (
//                       <option key={dept} value={dept}>{dept}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Designation:</label>
//                   <input
//                     type="text"
//                     name="designation"
//                     value={editForm.designation || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Designation"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Gender:</label>
//                   <select
//                     name="gender"
//                     value={editForm.gender || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   >
//                     <option value="">Select Gender</option>
//                     {genderOptions.map(gender => (
//                       <option key={gender} value={gender}>{gender}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Date of Birth:</label>
//                   <input
//                     type="date"
//                     name="dateOfBirth"
//                     value={editForm.dateOfBirth || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Street:</label>
//                   <input
//                     type="text"
//                     name="address.street"
//                     value={editForm.address?.street || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Street"
//                   />
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.city"
//                       value={editForm.address?.city || ''}
//                       onChange={handleInputChange}
//                       className="form-control"
//                       placeholder="City"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.state"
//                       value={editForm.address?.state || ''}
//                       onChange={handleInputChange}
//                       className="form-control"
//                       placeholder="State"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.pincode"
//                       value={editForm.address?.pincode || ''}
//                       onChange={handleInputChange}
//                       className="form-control"
//                       placeholder="Pincode"
//                     />
//                   </div>
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       name="address.country"
//                       value={editForm.address?.country || 'India'}
//                       onChange={handleInputChange}
//                       className="form-control"
//                       placeholder="Country"
//                     />
//                   </div>
//                 </div>
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={editForm.isActive || false}
//                       onChange={handleInputChange}
//                     />
//                     <span className="checkbox-text">Active Freelancer</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {editingFreelancer && isFetchingDetails && <SkeletonEditModal />}


//       {showPermissionsModal && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={() => setShowPermissionsModal(false)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Update Permissions</h3>
//               <button className="modal-close-btn" onClick={() => setShowPermissionsModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="permissions-form">
//                 <div className="permission-item">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="canManageDrivers"
//                       checked={permissionsForm.canManageDrivers}
//                       onChange={handlePermissionsChange}
//                     />
//                     Manage Drivers
//                   </label>
//                 </div>
//                 <div className="permission-item">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="canManageConductors"
//                       checked={permissionsForm.canManageConductors}
//                       onChange={handlePermissionsChange}
//                     />
//                     Manage Conductors
//                   </label>
//                 </div>
//                 <div className="permission-item">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="canManageBusOwners"
//                       checked={permissionsForm.canManageBusOwners}
//                       onChange={handlePermissionsChange}
//                     />
//                     Manage Bus Owners
//                   </label>
//                 </div>
//                 <div className="permission-item">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="canManageRoutes"
//                       checked={permissionsForm.canManageRoutes}
//                       onChange={handlePermissionsChange}
//                     />
//                     Manage Routes
//                   </label>
//                 </div>
//                 <div className="permission-item">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="canViewDashboard"
//                       checked={permissionsForm.canViewDashboard}
//                       onChange={handlePermissionsChange}
//                     />
//                     View Dashboard
//                   </label>
//                 </div>
//                 <div className="permission-item">
//                   <label>
//                     <input
//                       type="checkbox"
//                       name="canViewProfile"
//                       checked={permissionsForm.canViewProfile}
//                       onChange={handlePermissionsChange}
//                     />
//                     View Profile
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowPermissionsModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleUpdatePermissions}>
//                 Update Permissions
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showDeleteConfirm && (
//         <div className="modal-overlay" onClick={() => setShowDeleteConfirm(false)}>
//           <div className="modal-content1 confirm-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{deleteType === 'permanent' ? 'Permanently Delete Freelancer' : 'Toggle Freelancer Status'}</h3>
//               <button className="modal-close-btn" onClick={() => setShowDeleteConfirm(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>
//                 {deleteType === 'permanent' 
//                   ? 'Are you sure you want to permanently delete this freelancer? This action cannot be undone.'
//                   : 'Are you sure you want to change the status of this freelancer?'}
//               </p>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowDeleteConfirm(false)}>
//                 Cancel
//               </button>
//               <button 
//                 className={`action-btn ${deleteType === 'permanent' ? 'permanent-delete' : 'delete'}`} 
//                 onClick={handleDeleteFreelancer}
//               >
//                 {deleteType === 'permanent' ? 'Permanently Delete' : 'Confirm'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showBulkModal && (
//         <div className="modal-overlay" onClick={() => setShowBulkModal(false)}>
//           <div className="modal-content1 bulk-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bulk Create Freelancers</h3>
//               <button className="modal-close-btn" onClick={() => setShowBulkModal(false)}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>Enter JSON array of freelancers:</p>
//               <textarea
//                 value={bulkFreelancers}
//                 onChange={(e) => setBulkFreelancers(e.target.value)}
//                 className="bulk-textarea"
//                 rows={10}
//                 placeholder='[
//   {
//     "name": "John Doe",
//     "email": "john@example.com",
//     "password": "password123",
//     "phone": "+1234567890",
//     "department": "Operations",
//     "designation": "Freelancer"
//   }
// ]'
//               />
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={() => setShowBulkModal(false)}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleBulkCreate}>
//                 Create Freelancers
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FreelancerManagement;

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/FreelancerManage.css';     // freelancer-only additions (load LAST)
import {
  getFreelancers,
  getFreelancerById,
  createFreelancer,
  updateFreelancer,
  deleteFreelancer,
  permanentDeleteFreelancer,
  updateFreelancerPassword,
  bulkCreateFreelancers,
  approveFreelancer,
  rejectFreelancer,
  toggleFreelancerStatus,
  updateFreelancerPermissions,
  getFreelancerStats,
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const imgUrl = (p) => {
  if (!p) return '';
  if (p.startsWith('http')) return p;
  return `${process.env.REACT_APP_BASE_URL}/uploads/${p}`;
};

// ============================================================
// Freelancer card
// ============================================================
const FreelancerCard = ({ f, index, onView, onEdit, onApprove, onReject, onPassword, onPermissions, onDelete, isFetchingDetails }) => (
  <div className={`prm-card fl-card ${!f.isApproved ? 'pending' : ''}`} style={{ animationDelay: `${index * 60}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <Avatar name={f.name} src={imgUrl(f.profileImage)} size={52} />
        <div>
          <div className="prm-card-no">Freelancer #{String(f.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{f.name || 'N/A'}</h3>
          <div className="prm-card-sub"><Icon name="mail" size={14} /> {f.email || 'N/A'}</div>
        </div>
      </div>
      <div className="fl-card-badges">
        <span className={`prm-status ${f.isApproved ? 'active' : 'pending'}`}>
          {f.isApproved ? 'Approved' : 'Pending'}
        </span>
        <span className={`prm-status ${f.isActive ? 'active' : 'inactive'}`}>
          {f.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
    </div>

    <div className="pbo-contact">
      <div><Icon name="phone" size={14} /> {f.phone || 'N/A'}</div>
      {f.employeeId && <div><Icon name="info" size={14} /> ID: {f.employeeId}</div>}
      <div><Icon name="users" size={14} /> {f.department || 'N/A'} · {f.designation || 'N/A'}</div>
    </div>

    <div className="prm-metrics">
      <div className="prm-metric"><div className="v"><Icon name="check" size={15} /> {f.isApproved ? 'Yes' : 'No'}</div><div className="l">Approved</div></div>
      <div className="prm-metric"><div className="v"><Icon name="check" size={15} /> {f.isActive ? 'Yes' : 'No'}</div><div className="l">Active</div></div>
      <div className="prm-metric"><div className="v"><Icon name="calendar" size={15} /> {f.joined || 'N/A'}</div><div className="l">Joined</div></div>
    </div>

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(f.id)} disabled={isFetchingDetails}><Icon name="eye" size={14} /> View</button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(f.id)} disabled={isFetchingDetails}><Icon name="edit" size={14} /> Edit</button>
      {!f.isApproved && (
        <>
          <button className="prm-btn primary sm" onClick={() => onApprove(f.id)} disabled={isFetchingDetails}><Icon name="check" size={14} /> Approve</button>
          <button className="prm-btn danger sm" onClick={() => onReject(f.id)} disabled={isFetchingDetails}><Icon name="x" size={14} /> Reject</button>
        </>
      )}
      <button className="prm-btn ghost sm" onClick={() => onPassword(f.id)} disabled={isFetchingDetails}><Icon name="lock" size={14} /> Password</button>
      <button className="prm-btn ghost sm" onClick={() => onPermissions(f)} disabled={isFetchingDetails}><Icon name="info" size={14} /> Permissions</button>
      <button className="prm-btn danger sm" onClick={() => onDelete(f.id)} disabled={isFetchingDetails} title="Permanently Delete"><Icon name="trash" size={14} /> Delete</button>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const FreelancerManagement = () => {
  const { token } = useSelector(state => state.user);

  const [freelancers, setFreelancers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingFreelancer, setEditingFreelancer] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingFreelancer, setViewingFreelancer] = useState(null);
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [layout, setLayout] = useState('table');
  const [statusFilter, setStatusFilter] = useState('all');

  const [addForm, setAddForm] = useState({
    name: '', email: '', password: '', phone: '', dateOfBirth: '', gender: '',
    address: { street: '', city: '', state: '', pincode: '', country: 'India' },
    department: 'Operations', designation: 'Freelancer'
  });

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ newPassword: '' });
  const [selectedFreelancerId, setSelectedFreelancerId] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteType, setDeleteType] = useState('soft');
  const [freelancerToDelete, setFreelancerToDelete] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkFreelancers, setBulkFreelancers] = useState('');
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [permissionsForm, setPermissionsForm] = useState({
    canManageDrivers: true,
    canManageConductors: true,
    canManageBusOwners: true,
    canManageRoutes: true,
    canViewDashboard: true,
    canViewProfile: true
  });

  const [filters, setFilters] = useState({ status: '', approval: '' });
  const [stats, setStats] = useState({ total: 0, active: 0, pending: 0, inactive: 0 });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalFreelancers, setTotalFreelancers] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const genderOptions = ['male', 'female', 'other'];
  const departmentOptions = ['Operations', 'IT', 'HR', 'Finance', 'Sales', 'Marketing', 'Customer Support'];
  const statusOptions = ['active', 'inactive'];
  const approvalOptions = ['approved', 'pending'];

  const getSequentialNumber = (index) => (currentPage - 1) * pageSize + index + 1;

  useEffect(() => { fetchStats(); }, []); // eslint-disable-line

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => { fetchFreelancers(); }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchTerm, filters]);

  const fetchStats = async () => {
    try {
      const response = await getFreelancerStats(token);
      if (response.success) setStats(response.data);
    } catch (err) { console.error('Error fetching stats:', err); }
  };

  const fetchFreelancers = async () => {
    try {
      setSearching(true); setLoading(true);
      const response = await getFreelancers(token, currentPage, pageSize, searchTerm, filters.status, filters.approval);
      if (response && response.success) {
        setFreelancers(response.data.freelancers.map((freelancer, index) => ({
          id: freelancer._id,
          serialNo: getSequentialNumber(index),
          profileImage: freelancer.profilePicture,
          name: freelancer.name || '',
          email: freelancer.email || '',
          phone: freelancer.phone || '',
          employeeId: freelancer.employeeId || '',
          department: freelancer.department || '',
          designation: freelancer.designation || '',
          isActive: freelancer.isActive || false,
          isApproved: freelancer.isApproved || false,
          approvedBy: freelancer.approvedBy,
          joined: new Date(freelancer.createdAt).toISOString().split('T')[0],
          status: freelancer.isActive ? 'Active' : 'Inactive',
          approvalStatus: freelancer.isApproved ? 'Approved' : 'Pending',
          permissions: freelancer.permissions || {}
        })));
        setTotalPages(response.data.pagination.totalPages || 1);
        setTotalFreelancers(response.data.pagination.totalItems || 0);
      }
    } catch (err) {
      setError('Failed to fetch freelancers.');
      console.error('Error fetching freelancers:', err);
    } finally {
      setLoading(false); setSearching(false); setFirstLoad(false);
    }
  };

  const handleViewFreelancer = async (freelancerId) => {
    try {
      setIsFetchingDetails(true); setError(null);
      const response = await getFreelancerById(freelancerId, token);
      if (response.success) {
        const freelancer = response.data;
        setViewingFreelancer({
          id: freelancer._id,
          name: freelancer.name || '', email: freelancer.email || '', phone: freelancer.phone || '',
          employeeId: freelancer.employeeId || '',
          department: freelancer.department || '', designation: freelancer.designation || '',
          isActive: freelancer.isActive, isApproved: freelancer.isApproved,
          profileImage: freelancer.profilePicture,
          address: freelancer.address, gender: freelancer.gender,
          dateOfBirth: freelancer.dateOfBirth ? new Date(freelancer.dateOfBirth).toLocaleDateString() : 'N/A',
          permissions: freelancer.permissions,
          createdAt: new Date(freelancer.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
          updatedAt: new Date(freelancer.updatedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        });
      } else setError('Failed to fetch freelancer details.');
    } catch (err) {
      console.error('Error fetching freelancer details:', err);
      setError('Failed to fetch freelancer details.');
    } finally { setIsFetchingDetails(false); }
  };

  const handleEditFreelancer = async (freelancerId) => {
    try {
      setIsFetchingDetails(true); setError(null);
      const response = await getFreelancerById(freelancerId, token);
      if (response.success) {
        const freelancer = response.data;
        setEditingFreelancer(freelancer._id);
        setEditForm({
          name: freelancer.name || '', email: freelancer.email || '', phone: freelancer.phone || '',
          department: freelancer.department || 'Operations',
          designation: freelancer.designation || 'Freelancer',
          gender: freelancer.gender || '',
          dateOfBirth: freelancer.dateOfBirth ? freelancer.dateOfBirth.split('T')[0] : '',
          address: freelancer.address || { street: '', city: '', state: '', pincode: '', country: 'India' },
          isActive: freelancer.isActive || true
        });
      } else setError('Failed to fetch freelancer details for editing.');
    } catch (err) {
      console.error('Error fetching freelancer details for editing:', err);
      setError('Failed to fetch freelancer details for editing.');
    } finally { setIsFetchingDetails(false); }
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);
      const updateData = {
        name: editForm.name, email: editForm.email, phone: editForm.phone,
        department: editForm.department, designation: editForm.designation,
        gender: editForm.gender, dateOfBirth: editForm.dateOfBirth,
        address: editForm.address, isActive: editForm.isActive
      };
      const response = await updateFreelancer(editingFreelancer, updateData, token);
      if (response.success) {
        setFreelancers(prev => prev.map(f => f.id === editingFreelancer ? {
          ...f,
          name: response.data.name,
          email: response.data.email,
          phone: response.data.phone,
          department: response.data.department,
          designation: response.data.designation,
          status: response.data.isActive ? 'Active' : 'Inactive',
          isActive: response.data.isActive
        } : f));
        setEditingFreelancer(null);
        setEditForm({});
        alert('Freelancer updated successfully!');
      } else setError(response.message || 'Failed to update freelancer.');
    } catch (err) {
      console.error('Error updating freelancer:', err);
      setError(err.response?.data?.message || 'Failed to update freelancer. Please try again.');
      alert('Failed to update freelancer. Please try again.');
    }
  };

  const handleAddFreelancer = async () => {
    try {
      setError(null);
      const response = await createFreelancer(addForm, token);
      if (response.success) {
        setShowAddModal(false);
        setAddForm({
          name: '', email: '', password: '', phone: '', dateOfBirth: '', gender: '',
          address: { street: '', city: '', state: '', pincode: '', country: 'India' },
          department: 'Operations', designation: 'Freelancer'
        });
        fetchFreelancers(); fetchStats();
        alert('Freelancer created successfully!');
      } else setError(response.message || 'Failed to create freelancer.');
    } catch (err) {
      console.error('Error creating freelancer:', err);
      setError(err.response?.data?.message || 'Failed to create freelancer. Please try again.');
    }
  };

  const handleUpdatePassword = async () => {
    try {
      setError(null);
      const response = await updateFreelancerPassword(selectedFreelancerId, passwordForm, token);
      if (response.success) {
        setShowPasswordModal(false);
        setPasswordForm({ newPassword: '' });
        setSelectedFreelancerId(null);
        alert('Password updated successfully!');
      } else setError(response.message || 'Failed to update password.');
    } catch (err) {
      console.error('Error updating password:', err);
      setError(err.response?.data?.message || 'Failed to update password. Please try again.');
    }
  };

  const handleDeleteFreelancer = async () => {
    try {
      setError(null);
      let response;
      if (deleteType === 'permanent') response = await permanentDeleteFreelancer(freelancerToDelete, token);
      else response = await deleteFreelancer(freelancerToDelete, token);
      if (response.success) {
        setShowDeleteConfirm(false);
        setFreelancerToDelete(null);
        fetchFreelancers(); fetchStats();
        alert(`Freelancer ${deleteType === 'permanent' ? 'permanently deleted' : 'deactivated'} successfully!`);
      } else setError(response.message || 'Failed to delete freelancer.');
    } catch (err) {
      console.error('Error deleting freelancer:', err);
      setError(err.response?.data?.message || 'Failed to delete freelancer. Please try again.');
    }
  };

  const handleApproveFreelancer = async (freelancerId) => {
    try {
      const response = await approveFreelancer(freelancerId, token);
      if (response.success) { fetchFreelancers(); fetchStats(); alert('Freelancer approved successfully!'); }
    } catch (err) {
      console.error('Error approving freelancer:', err);
      setError('Failed to approve freelancer.');
    }
  };

  const handleRejectFreelancer = async (freelancerId) => {
    try {
      const response = await rejectFreelancer(freelancerId, token);
      if (response.success) { fetchFreelancers(); fetchStats(); alert('Freelancer rejected successfully!'); }
    } catch (err) {
      console.error('Error rejecting freelancer:', err);
      setError('Failed to reject freelancer.');
    }
  };

  const handleToggleStatus = async (freelancerId) => {
    try {
      const response = await toggleFreelancerStatus(freelancerId, token);
      if (response.success) {
        fetchFreelancers(); fetchStats();
        alert(`Freelancer ${response.data.isActive ? 'activated' : 'deactivated'} successfully!`);
      }
    } catch (err) {
      console.error('Error toggling freelancer status:', err);
      setError('Failed to toggle freelancer status.');
    }
  };

  const handleUpdatePermissions = async () => {
    try {
      const response = await updateFreelancerPermissions(selectedFreelancerId, permissionsForm, token);
      if (response.success) {
        setShowPermissionsModal(false);
        setSelectedFreelancerId(null);
        alert('Permissions updated successfully!');
      }
    } catch (err) {
      console.error('Error updating permissions:', err);
      setError('Failed to update permissions.');
    }
  };

  const handleBulkCreate = async () => {
    try {
      setError(null);
      if (!bulkFreelancers || bulkFreelancers.trim() === '') { setError('Please enter freelancer data.'); return; }
      let freelancersData;
      try { freelancersData = JSON.parse(bulkFreelancers); }
      catch (e) { setError('Invalid JSON format. Please check your input. Error: ' + e.message); return; }
      if (!Array.isArray(freelancersData)) {
        setError('Invalid format: Please provide an array of freelancers. Example: [{ "name": "John", "email": "john@example.com", "password": "password123" }]');
        return;
      }
      if (freelancersData.length === 0) { setError('Please provide at least one freelancer to create.'); return; }
      const requiredFields = ['name', 'email', 'password'];
      const missingFields = [];
      freelancersData.forEach((item, index) => {
        requiredFields.forEach(field => {
          if (!item[field] || item[field].trim() === '') missingFields.push(`Item ${index + 1}: Missing "${field}"`);
        });
      });
      if (missingFields.length > 0) { setError(`Missing required fields:\n${missingFields.join('\n')}`); return; }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const invalidEmails = [];
      freelancersData.forEach((item, index) => {
        if (item.email && !emailRegex.test(item.email)) invalidEmails.push(`Item ${index + 1}: Invalid email "${item.email}"`);
      });
      if (invalidEmails.length > 0) { setError(`Invalid email format:\n${invalidEmails.join('\n')}`); return; }
      const shortPasswords = [];
      freelancersData.forEach((item, index) => {
        if (item.password && item.password.length < 8) shortPasswords.push(`Item ${index + 1}: Password must be at least 8 characters`);
      });
      if (shortPasswords.length > 0) { setError(`Password requirements:\n${shortPasswords.join('\n')}`); return; }

      const response = await bulkCreateFreelancers(freelancersData, token);
      if (response.success) {
        setShowBulkModal(false);
        setBulkFreelancers('');
        fetchFreelancers(); fetchStats();
        alert(`${response.data.created?.length || freelancersData.length} freelancers created successfully!`);
      } else setError(response.message || 'Failed to create freelancers.');
    } catch (err) {
      console.error('Error bulk creating freelancers:', err);
      setError(err.response?.data?.message || 'Failed to create freelancers. Please try again.');
    }
  };

  const handleCancelEdit = () => { setEditingFreelancer(null); setEditForm({}); setError(null); };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setEditForm(prev => ({ ...prev, [parent]: { ...prev[parent], [child]: value } }));
    } else setEditForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleAddFormChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setAddForm(prev => ({ ...prev, [parent]: { ...prev[parent], [child]: value } }));
    } else setAddForm(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordFormChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({ ...prev, [name]: value }));
  };

  const handlePermissionsChange = (e) => {
    const { name, checked } = e.target;
    setPermissionsForm(prev => ({ ...prev, [name]: checked }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const closeViewModal = () => setViewingFreelancer(null);
  const handleSearchChange = (e) => { setSearchTerm(e.target.value); setCurrentPage(1); };
  const handleRefresh = () => {
    setCurrentPage(1); setSearchTerm(''); setStatusFilter('all');
    setFilters({ status: '', approval: '' });
    fetchFreelancers(); fetchStats();
  };

  const handleExportCSV = () => {
    const headers = ['Name', 'Email', 'Phone', 'Employee ID', 'Department', 'Designation', 'Status', 'Approval', 'Joined'];
    const csvData = freelancers.map(f => [f.name, f.email, f.phone, f.employeeId, f.department, f.designation, f.status, f.approvalStatus, f.joined]);
    const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `freelancers_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const visible = useMemo(() => {
    if (statusFilter === 'all') return freelancers;
    return freelancers.filter(f => {
      if (statusFilter === 'active') return f.isActive;
      if (statusFilter === 'inactive') return !f.isActive;
      if (statusFilter === 'pending') return !f.isApproved;
      if (statusFilter === 'approved') return f.isApproved;
      return true;
    });
  }, [freelancers, statusFilter]);

  /* ---------------- Loading ---------------- */
  if (firstLoad && loading && freelancers.length === 0) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Freelancers</span>
          <h1>Freelancer Management</h1><p>Loading freelancers…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Freelancer Insights</span>
          <h1>Freelancer Management</h1>
          <p>Manage freelancer accounts, approve access and configure their permissions.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input type="text" placeholder="Search by name, email or phone…" value={searchTerm} onChange={handleSearchChange} />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh"><Icon name="refresh" size={17} /></button>
          <button className="prm-btn ghost sm" onClick={handleExportCSV}><Icon name="download" size={14} /> Export CSV</button>
          <button className="prm-btn ghost sm" onClick={() => setShowBulkModal(true)}><Icon name="plus" size={14} /> Bulk Create</button>
          <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
            <span className="plus"><Icon name="plus" size={14} /></span> Add Freelancer
          </button>
        </div>
      </div>

      {error && <div className="fl-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={handleRefresh}>Retry</button></div>}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="users" tone="indigo" label="Total Freelancers" value={stats.total} hint="All registered freelancers" delay={80} />
        <StatCard icon="check" tone="green" label="Active" value={stats.active} hint="Active freelancers" delay={160} />
        <StatCard icon="clock" tone="amber" label="Pending Approval" value={stats.pending} hint="Awaiting approval" delay={240} />
        <StatCard icon="x" tone="red" label="Inactive" value={stats.inactive} hint="Deactivated" delay={320} />
      </div>

      {/* FILTERS */}
      <div className="fl-filter-strip">
        <Field label="Status">
          <select name="status" value={filters.status} onChange={handleFilterChange} className="prm-input prm-select">
            <option value="">All Status</option>
            {statusOptions.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </Field>
        <Field label="Approval">
          <select name="approval" value={filters.approval} onChange={handleFilterChange} className="prm-input prm-select">
            <option value="">All Approval</option>
            {approvalOptions.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </Field>
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {[['all', 'All', freelancers.length], ['active', 'Active', stats.active], ['inactive', 'Inactive', stats.inactive], ['pending', 'Pending', stats.pending]].map(([k, l, c]) => (
              <button key={k} className={`prm-chip ${statusFilter === k ? 'active' : ''}`} onClick={() => setStatusFilter(k)}>
                {l} <span className="count">{c}</span>
              </button>
            ))}
          </div>
          {searchTerm && <span className="prm-tag amber">Search: "{searchTerm}"</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{visible.length}</b> of {totalFreelancers}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view"><Icon name="grid" size={17} /></button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view"><Icon name="list" size={17} /></button>
          </div>
        </div>
      </div>

      {/* LIST */}
      <div className={(loading || searching) ? 'fl-loading' : ''}>
        {visible.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm ? 'search' : 'users'} size={44} /></div>
            <h3>{searchTerm ? 'No freelancers match your search' : 'No freelancers yet'}</h3>
            <p>{searchTerm ? 'Try a different search term or clear filters.' : 'Registered freelancers will appear here.'}</p>
            {(searchTerm || statusFilter !== 'all' || filters.status || filters.approval) && (
              <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>
            )}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {visible.map((f, i) => (
              <FreelancerCard key={f.id} f={f} index={i}
                onView={handleViewFreelancer}
                onEdit={handleEditFreelancer}
                onApprove={handleApproveFreelancer}
                onReject={handleRejectFreelancer}
                onPassword={(id) => { setSelectedFreelancerId(id); setShowPasswordModal(true); }}
                onPermissions={(fl) => { setSelectedFreelancerId(fl.id); setPermissionsForm(fl.permissions); setShowPermissionsModal(true); }}
                onDelete={(id) => { setFreelancerToDelete(id); setDeleteType('permanent'); setShowDeleteConfirm(true); }}
                isFetchingDetails={isFetchingDetails}
              />
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th>No.</th><th>Name</th><th>Email</th><th>Phone</th><th>Employee ID</th>
                  <th>Department</th><th>Designation</th><th>Status</th><th>Approval</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {visible.map((f, i) => (
                  <tr key={f.id} className={!f.isApproved ? 'fl-pending-row' : ''} style={{ animationDelay: `${i * 40}ms` }}>
                    <td>{f.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={f.name} src={imgUrl(f.profileImage)} size={38} />
                        <div className="name">{f.name || 'N/A'}</div>
                      </div>
                    </td>
                    <td>{f.email || 'N/A'}</td>
                    <td>{f.phone || 'N/A'}</td>
                    <td>{f.employeeId || 'N/A'}</td>
                    <td>{f.department || 'N/A'}</td>
                    <td>{f.designation || 'N/A'}</td>
                    <td><span className={`prm-status ${f.isActive ? 'active' : 'inactive'}`}>{f.status}</span></td>
                    <td><span className={`prm-status ${f.isApproved ? 'active' : 'pending'}`}>{f.approvalStatus}</span></td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewFreelancer(f.id)} disabled={isFetchingDetails} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleEditFreelancer(f.id)} disabled={isFetchingDetails} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                        {!f.isApproved && (
                          <>
                            <button className="prm-btn primary sm icon-only" onClick={() => handleApproveFreelancer(f.id)} disabled={isFetchingDetails} title="Approve" aria-label="Approve"><Icon name="check" size={14} /></button>
                            <button className="prm-btn danger sm icon-only" onClick={() => handleRejectFreelancer(f.id)} disabled={isFetchingDetails} title="Reject" aria-label="Reject"><Icon name="x" size={14} /></button>
                          </>
                        )}
                        <button className="prm-btn ghost sm icon-only" onClick={() => { setSelectedFreelancerId(f.id); setShowPasswordModal(true); }} disabled={isFetchingDetails} title="Change Password" aria-label="Change Password"><Icon name="lock" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => { setSelectedFreelancerId(f.id); setPermissionsForm(f.permissions); setShowPermissionsModal(true); }} disabled={isFetchingDetails} title="Permissions" aria-label="Permissions"><Icon name="info" size={14} /></button>
                        <button className="prm-btn danger sm icon-only" onClick={() => { setFreelancerToDelete(f.id); setDeleteType('permanent'); setShowDeleteConfirm(true); }} disabled={isFetchingDetails} title="Delete" aria-label="Delete"><Icon name="trash" size={14} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalFreelancers}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="freelancers"
      />

      {/* VIEW MODAL */}
      {viewingFreelancer && !isFetchingDetails && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingFreelancer.name} src={imgUrl(viewingFreelancer.profileImage)} size={52} />
                <div>
                  <h3>{viewingFreelancer.name || 'Freelancer'}</h3>
                  <p>{viewingFreelancer.email || 'N/A'} · {viewingFreelancer.phone || 'N/A'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Status</span><b className={viewingFreelancer.isActive ? 'fl-ok' : 'fl-off'}>{viewingFreelancer.isActive ? 'Active' : 'Inactive'}</b></div>
                <div><span>Approval</span><b className={viewingFreelancer.isApproved ? 'fl-ok' : ''}>{viewingFreelancer.isApproved ? 'Approved' : 'Pending'}</b></div>
                <div><span>Department</span><b>{viewingFreelancer.department || 'N/A'}</b></div>
                <div><span>Designation</span><b>{viewingFreelancer.designation || 'N/A'}</b></div>
              </div>

              <div className="prm-section-title">Basic information</div>
              <div className="fl-grid">
                <div><small>Employee ID</small><b>{viewingFreelancer.employeeId || 'N/A'}</b></div>
                <div><small>Gender</small><b>{viewingFreelancer.gender || 'N/A'}</b></div>
                <div><small>Date of Birth</small><b>{viewingFreelancer.dateOfBirth || 'N/A'}</b></div>
              </div>

              {viewingFreelancer.address && (
                <>
                  <div className="prm-section-title">Address</div>
                  <div className="fl-grid">
                    <div style={{ gridColumn: '1 / -1' }}>
                      <b>
                        {[viewingFreelancer.address.street, viewingFreelancer.address.city, viewingFreelancer.address.state, viewingFreelancer.address.pincode, viewingFreelancer.address.country].filter(Boolean).join(', ') || 'N/A'}
                      </b>
                    </div>
                  </div>
                </>
              )}

              {viewingFreelancer.permissions && (
                <>
                  <div className="prm-section-title">Permissions</div>
                  <div className="fl-grid">
                    <div><small>Manage Drivers</small><b>{viewingFreelancer.permissions.canManageDrivers ? '✅ Yes' : '❌ No'}</b></div>
                    <div><small>Manage Conductors</small><b>{viewingFreelancer.permissions.canManageConductors ? '✅ Yes' : '❌ No'}</b></div>
                    <div><small>Manage Bus Owners</small><b>{viewingFreelancer.permissions.canManageBusOwners ? '✅ Yes' : '❌ No'}</b></div>
                    <div><small>Manage Routes</small><b>{viewingFreelancer.permissions.canManageRoutes ? '✅ Yes' : '❌ No'}</b></div>
                    <div><small>View Dashboard</small><b>{viewingFreelancer.permissions.canViewDashboard ? '✅ Yes' : '❌ No'}</b></div>
                    <div><small>View Profile</small><b>{viewingFreelancer.permissions.canViewProfile ? '✅ Yes' : '❌ No'}</b></div>
                  </div>
                </>
              )}

              <div className="prm-section-title">System information</div>
              <div className="fl-grid">
                <div><small>Created</small><b>{viewingFreelancer.createdAt}</b></div>
                <div><small>Last Updated</small><b>{viewingFreelancer.updatedAt}</b></div>
              </div>
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={closeViewModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {viewingFreelancer && isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}

      {/* ADD MODAL */}
      {showAddModal && (
        <div className="prm-overlay" onClick={() => setShowAddModal(false)}>
          <div className="prm-form-modal pbo-fleet" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="plus" size={22} /></span>
                <div><h3>Add new freelancer</h3><p>Create a new freelancer account</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowAddModal(false)}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="prm-section-title">Basic information</div>
              <div className="prm-fgrid">
                <Field label="Name" required><input type="text" name="name" value={addForm.name} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Email" required><input type="email" name="email" value={addForm.email} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Password" required><input type="password" name="password" value={addForm.password} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Phone" required><input type="text" name="phone" value={addForm.phone} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Gender">
                  <select name="gender" value={addForm.gender} onChange={handleAddFormChange} className="prm-input prm-select">
                    <option value="">Select Gender</option>
                    {genderOptions.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </Field>
                <Field label="Date of Birth"><input type="date" name="dateOfBirth" value={addForm.dateOfBirth} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Department">
                  <select name="department" value={addForm.department} onChange={handleAddFormChange} className="prm-input prm-select">
                    {departmentOptions.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                </Field>
                <Field label="Designation"><input type="text" name="designation" value={addForm.designation} onChange={handleAddFormChange} className="prm-input" /></Field>
              </div>

              <div className="prm-section-title">Address</div>
              <div className="prm-fgrid">
                <Field label="Street"><input type="text" name="address.street" value={addForm.address.street} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="City"><input type="text" name="address.city" value={addForm.address.city} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="State"><input type="text" name="address.state" value={addForm.address.state} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Pincode"><input type="text" name="address.pincode" value={addForm.address.pincode} onChange={handleAddFormChange} className="prm-input" /></Field>
                <Field label="Country"><input type="text" name="address.country" value={addForm.address.country} onChange={handleAddFormChange} className="prm-input" /></Field>
              </div>
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowAddModal(false)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleAddFreelancer}>Create Freelancer</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {editingFreelancer && !isFetchingDetails && (
        <div className="prm-overlay" onClick={handleCancelEdit}>
          <div className="prm-form-modal pbo-fleet" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>Edit freelancer</h3><p>{editForm.email || editForm.name}</p></div>
              </div>
              <button className="prm-modal-close" onClick={handleCancelEdit}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="prm-section-title">Basic information</div>
              <div className="prm-fgrid">
                <Field label="Name"><input type="text" name="name" value={editForm.name || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Email"><input type="email" name="email" value={editForm.email || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Phone"><input type="text" name="phone" value={editForm.phone || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Department">
                  <select name="department" value={editForm.department || 'Operations'} onChange={handleInputChange} className="prm-input prm-select">
                    {departmentOptions.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                </Field>
                <Field label="Designation"><input type="text" name="designation" value={editForm.designation || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Gender">
                  <select name="gender" value={editForm.gender || ''} onChange={handleInputChange} className="prm-input prm-select">
                    <option value="">Select Gender</option>
                    {genderOptions.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </Field>
                <Field label="Date of Birth"><input type="date" name="dateOfBirth" value={editForm.dateOfBirth || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Status">
                  <label className="fl-toggle">
                    <input type="checkbox" name="isActive" checked={editForm.isActive || false} onChange={handleInputChange} />
                    <span>{editForm.isActive ? 'Active' : 'Inactive'}</span>
                  </label>
                </Field>
              </div>

              <div className="prm-section-title">Address</div>
              <div className="prm-fgrid">
                <Field label="Street"><input type="text" name="address.street" value={editForm.address?.street || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="City"><input type="text" name="address.city" value={editForm.address?.city || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="State"><input type="text" name="address.state" value={editForm.address?.state || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Pincode"><input type="text" name="address.pincode" value={editForm.address?.pincode || ''} onChange={handleInputChange} className="prm-input" /></Field>
                <Field label="Country"><input type="text" name="address.country" value={editForm.address?.country || 'India'} onChange={handleInputChange} className="prm-input" /></Field>
              </div>
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={handleCancelEdit}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit}>Save changes</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingFreelancer && isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}

      {/* PASSWORD MODAL */}
      {showPasswordModal && (
        <div className="prm-overlay" onClick={() => setShowPasswordModal(false)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="lock" size={22} /></span>
                <div><h3>Reset password</h3><p>Set a new password for this freelancer</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowPasswordModal(false)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="New Password" required><input type="password" name="newPassword" value={passwordForm.newPassword} onChange={handlePasswordFormChange} className="prm-input" /></Field>
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Minimum 8 characters</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowPasswordModal(false)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleUpdatePassword}>Reset Password</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PERMISSIONS MODAL */}
      {showPermissionsModal && (
        <div className="prm-overlay" onClick={() => setShowPermissionsModal(false)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="info" size={22} /></span>
                <div><h3>Update permissions</h3><p>Configure what this freelancer can access</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowPermissionsModal(false)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="fl-permissions-list">
                {[
                  ['canManageDrivers', 'Manage Drivers'],
                  ['canManageConductors', 'Manage Conductors'],
                  ['canManageBusOwners', 'Manage Bus Owners'],
                  ['canManageRoutes', 'Manage Routes'],
                  ['canViewDashboard', 'View Dashboard'],
                  ['canViewProfile', 'View Profile'],
                ].map(([name, label]) => (
                  <label key={name} className="fl-permission-item">
                    <input type="checkbox" name={name} checked={permissionsForm[name]} onChange={handlePermissionsChange} />
                    <span>{label}</span>
                  </label>
                ))}
              </div>
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowPermissionsModal(false)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleUpdatePermissions}>Update Permissions</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DELETE CONFIRM */}
      {showDeleteConfirm && (
        <div className="prm-overlay" onClick={() => setShowDeleteConfirm(false)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="trash" size={22} /></span>
                <div><h3>{deleteType === 'permanent' ? 'Permanently delete freelancer' : 'Toggle freelancer status'}</h3></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowDeleteConfirm(false)}>×</button>
            </div>
            <div className="prm-form-body">
              <p style={{ color: '#475569', fontSize: 14, lineHeight: 1.6 }}>
                {deleteType === 'permanent'
                  ? 'Are you sure you want to permanently delete this freelancer? This action cannot be undone.'
                  : 'Are you sure you want to change the status of this freelancer?'}
              </p>
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowDeleteConfirm(false)}>Cancel</button>
                <button className="prm-btn danger" onClick={handleDeleteFreelancer}>
                  {deleteType === 'permanent' ? 'Permanently Delete' : 'Confirm'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* BULK MODAL */}
      {showBulkModal && (
        <div className="prm-overlay" onClick={() => setShowBulkModal(false)}>
          <div className="prm-form-modal pbo-fleet" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="plus" size={22} /></span>
                <div><h3>Bulk create freelancers</h3><p>Paste a JSON array of freelancers</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowBulkModal(false)}>×</button>
            </div>
            <div className="prm-form-body">
              <p style={{ color: '#475569', fontSize: 13, marginBottom: 12 }}>Enter JSON array of freelancers:</p>
              <textarea
                value={bulkFreelancers}
                onChange={(e) => setBulkFreelancers(e.target.value)}
                className="prm-input"
                rows={12}
                style={{ fontFamily: 'monospace', fontSize: 12 }}
                placeholder='[{"name":"John Doe","email":"john@example.com","password":"password123","phone":"+1234567890","department":"Operations","designation":"Freelancer"}]'
              />
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowBulkModal(false)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleBulkCreate}>Create Freelancers</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FreelancerManagement;